/* (c) Copyright Frontify Ltd., all rights reserved. */

import { createFondueIcon } from '../createFondueIcon';

/**
 * @component @name PlayFilled
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBmaWxsPSJjdXJyZW50Q29sb3IiIGQ9Ik00LjY0IDE5LjE1MlY0Ljc3YTEgMSAwIDAxMS40OTctLjg2OGwxMi42MjYgNy4yMjZhMSAxIDAgMDEtLjAwNCAxLjczOEw2LjEzMyAyMC4wMjJhMSAxIDAgMDEtMS40OTMtLjg3Ii8+PC9zdmc+) - https://fondue-components.frontify.com/?path=/story/icons-icons--default&args=iconName:play-filled
 * @see https://fondue-components.frontify.com/?path=/story/icons-icons--default - Documentation
 */
export const IconPlayFilled = createFondueIcon('PlayFilled', [["path",{"fill":"currentColor","d":"M4.64 19.152V4.77a1 1 0 011.497-.868l12.626 7.226a1 1 0 01-.004 1.738L6.133 20.022a1 1 0 01-1.493-.87"}]]);
